module.exports = __webpack_public_path__ + "img/play_icon.416e6385.svg";